var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.clone
    ? _c("div", { staticClass: "block-editor ai-bot-response payload" }, [
        _c(
          "div",
          { staticClass: "ready-templates" },
          [
            !_vm.showTemplates
              ? _c(
                  "span",
                  {
                    staticClass: "btnImport",
                    on: {
                      click: function ($event) {
                        _vm.showTemplates = true
                      },
                    },
                  },
                  [_vm._v("Import From Ready Templates")]
                )
              : _c(
                  "a-select",
                  {
                    staticStyle: { width: "300px" },
                    attrs: {
                      placeholder: "Template Seçiniz",
                      autofocus: true,
                      "default-open": true,
                    },
                    on: { change: _vm.injectTemplate },
                  },
                  _vm._l(_vm.templates, function (template) {
                    return _c(
                      "a-select-option",
                      { key: template.slug, attrs: { value: template.slug } },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(template.name) +
                            "\n            "
                        ),
                      ]
                    )
                  }),
                  1
                ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "says" },
          [
            _c("TiptapEditor", {
              key: "tiptap-prompt" + _vm.renderKey,
              attrs: {
                "show-emoji": true,
                "show-attributes": true,
                placeholder: "Bot Senaryosu",
                "max-character-count": 6200,
              },
              model: {
                value: _vm.clone.prompt,
                callback: function ($$v) {
                  _vm.$set(_vm.clone, "prompt", $$v)
                },
                expression: "clone.prompt",
              },
            }),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }